import {createColumnHelper} from "@tanstack/react-table";
import Card from "../../../components/UI/Card";
import Table from "../../../components/UI/Table";
import {getUsers} from "../../../api/user";
import React, {useEffect, useState} from "react";
import UsersForm from "../../../views/users/UsersForm";
import CardCreateNewButton from "../../../components/UI/CardCreateNewButton";
import UserFormTableAction from "../../../views/users/UserFormTableAction";
import {useMutation} from "@tanstack/react-query";
import {getRoles} from "../../../api/userRoles";
import {checkPermission} from "../../../util/auth";
import {useNavigate} from "react-router";

const UsersList = () => {
  const [openModal, setOpenModal] = useState(false)
  const [user, setEditUser] = useState(null)
  const [roles, setRoles] = useState([])

  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['USER_READ'])){
      navigate("/no-access");
    }
  }, [navigate]);

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Name'
    }),
    columnHelper.accessor('email', {
      id: 'email',
      header: 'Email'
    }),
    columnHelper.accessor('last_login', {
      id: 'last_login',
      header: 'Last Login'
    }),

    columnHelper.display( {
      id: 'actions',
      header: "Actions",
      classes:'text_right',
      cell: props => <UserFormTableAction editRecord={(data)=>handleEditUser(data)}  row={props.row.original} />
    }),
  ];

  const handleEditUser = (data) => {
    setEditUser(data)

    setOpenModal(true)
  }

  const { mutate:roleMutate} = useMutation({
    mutationFn: getRoles,
    onSuccess: (res) => {
      setRoles(res.data)
    },
  });

  useEffect(()=>{
    if(!roles.length){
      roleMutate()
    }
  }, [roles])

  return (
      <>
        <Card title={"Users"} CardActions={checkPermission(['USER_CREATE']) && <CardCreateNewButton clickHandler={()=>handleEditUser(null)} />}>
          <Table
              queryKey={"users"}
              columns={columns}
              queryParams={{per_page: 10}}
              queryFn={getUsers}
          />
        </Card>

        {openModal &&
        <UsersForm editRecord={user}
                   roles={roles}
                   openModal={openModal}
                   setEditUser={setEditUser}
                   setOpenModal={setOpenModal} />
        }

      </>
  )
}

export default UsersList;